<template>
  <div
    class="bg-ontick-steel-100 dark:bg-ontick-carbon-500 z-30 hidden w-full items-center lg:flex"
  >
    <div @click="menu = !menu" v-click-outside="activeMercado" class="relative">
      <transition
        enter-active-class="transform transition ease-in-out duration-500 sm:duration-700"
        enter-class="translate-y-full"
        enter-to-class="translate-y-0"
        leave-active-class="transform transition ease-in-out duration-500 sm:duration-700"
        leave-class="translate-y-0"
        leave-to-class="translate-y-full"
      >
        <nav
          v-show="menu"
          class="bg-ontick-steel-100 dark:bg-ontick-carbon-500 absolute bottom-10 left-4 flex rounded-xl bg-opacity-90 px-4 py-6 backdrop-blur-sm backdrop-opacity-90 backdrop-filter"
        >
          <div class="flex items-center pb-4">
            <span v-html="$icons.logo_onticker" />
          </div>

          <div
            @click.stop="active_ticker = !active_ticker"
            class="flex h-5 items-center"
          >
            <input
              name="active"
              type="checkbox"
              v-model="active_ticker"
              :class="
                active_ticker
                  ? 'text-ontick-blue-600 focus:ring-ontick-blue-500'
                  : ''
              "
              class="h-4 w-4 rounded border-gray-300"
            />
          </div>
        </nav>
      </transition>
      <div
        class="bg-ontick-steel-100 dark:bg-ontick-carbon-500 relative z-10 flex items-center space-x-2 py-6 px-6"
      >
        <span class="text-gray-500" v-html="$icons.menu"></span>
        <span class="text-ontick-steel-900 uppercase dark:text-white"
          >Mercado</span
        >
        <p
          class="font-semibold uppercase"
          :class="
            market_status == 'ABERTO'
              ? 'text-ontick-green-700 dark:text-ontick-green-500'
              : 'text-ontick-red-600 dark:text-ontick-red-500'
          "
        >
          {{ market_status }}
        </p>
      </div>
    </div>
    <div v-show="active_ticker" class="relative">
      <div
        class="from-ontick-steel-100 dark:from-ontick-carbon-500 absolute left-0 z-10 h-full w-40 bg-gradient-to-r"
      ></div>
      <marquee-text :paused="pause" :duration="20" :repeat="4">
        <div
          class="flex"
          @mouseover="pause = true"
          @mouseleave="active_index ? (pause = true) : (pause = false)"
        >
          <div
            v-for="(item, index) in data"
            :key="index"
            v-click-outside="closeDetails"
          >
            <ticker-cell-component
              :item="item"
              :active_index="active_index"
              @active-index="activeIndex"
            />
          </div>
        </div>
      </marquee-text>
    </div>
  </div>
</template>

<script>
import ClickOutside from "vue-click-outside";
import MarqueeText from "vue-marquee-text-component";
import DashboardBadgeComponent from "../../../modules/dashboard/components/dashboard.badge.component.vue";
import TickerCellComponent from "./ticker-cell.component.vue";

export default {
  name: "Ticket",
  components: { MarqueeText, DashboardBadgeComponent, TickerCellComponent },

  data() {
    return {
      data: [],
      data_details: {},
      // chart: [],
      pause: false,
      market_status: "FECHADO",
      interval: null,
      active_details: false,
      active_index: null,
      selected: { symbol: null, decimal: null },
      menu: false,
      active_ticker: true,
      active: true,
      observer: null,
      posBoxA: 0,
      posBoxB: 0,
    };
  },

  directives: {
    ClickOutside,
  },

  created() {
    this.getTicker();
    this.interval = setInterval(() => this.getTicker(), 30000);
  },

  watch: {
    active_ticker(val) {
      if (!val) {
        clearInterval(this.interval);
      } else {
        this.interval = setInterval(() => this.getTicker(), 30000);
      }
    },
  },

  methods: {
    closeDetails() {
      this.active_index = null;
      this.pause = false;
    },
    activeIndex(value) {
      this.active_index = value;
    },
    activeMercado() {
      this.menu = false;
    },

    activeBadge() {
      this.active_details = false;
      this.pause = false;
    },
    activeItem(value, index) {
      if (this.active_index == index) {
        this.active_details = false;
        this.active_index = null;
      } else {
        this.tickerDetails(value.symbol);
        this.active_details = true;
        this.active_index = index;
      }
    },

    tickerDetails(symbol) {
      this.$api
        .get(`${this.$endpoint.GET_TICKER_DETAILS}/${symbol}`)
        .then((response) => {
          this.data_details = response.data.summary;
          this.chart = response.data.sparkline;
        });
    },

    getTicker() {
      this.$api.get(this.$endpoint.GET_TICKER).then((response) => {
        this.data = response.data.snapshots;
        this.market_status = response.data.market_status;
      });
    },
  },

  unmounted() {
    clearInterval(this.interval);
  },
};
</script>

<style lang="scss">
.marquee-text-wrap {
  @apply overflow-visible #{!important};
}

.checkbox {
  @apply flex items-center rounded-md  py-2 text-right;
}
.checkbox > .border {
  width: 25px;
  height: 25px;
  box-sizing: border-box;
  border: 2px solid #07a4ff;
  padding: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  @apply rounded-md;
}
.checkbox > .border > .inner {
  transition: 0.2s all linear;
  background-color: #07a4ff;
  width: 0px;
  height: 0px;
}
.checkbox > .border .checked {
  transition: 0.2s width height linear;
  width: 25px;
  height: 25px;
  @apply rounded-md;
}
.company {
  &-move {
    transition: all 600ms ease-in-out 50ms;
  }
  &-enter-active {
    transition: all 300ms ease-out;
  }

  &-leave-active {
    transition: all 200ms ease-in;
    position: absolute;
    z-index: 0;
  }

  &-enter,
  &-leave-to {
    opacity: 0;
  }
  &-enter {
    transform: scale(0.9);
  }
}
</style>
